import React from "react";
import "./TrainingCalendarMain.css";
import Floaticons from "../../Floaticons";
import MenuNavbar from "../../MenuNavbar";
import CalendarHome from "../../../pages/CalendarHome";
import { Container } from 'react-bootstrap'

function TrainingCalendarMain() {
    return (
        <>
            <Floaticons />
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <div className="calender-heading">
                <h2>Security Instructor Lead Trainings</h2>
            </div>
            <div className="calendar-container">
                <Container fluid>
                    <div className="container__width">
                        <CalendarHome />
                    </div>
                </Container>
            </div>

        </>
    );
}

export default TrainingCalendarMain;
